module.exports = __webpack_public_path__ + "img/Xcode-icon.f9d70de4.svg";